import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { FaSignOutAlt, FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';
import styles from './AppHeader.module.scss';
import getConfig from '../../config';
import PropTypes from 'prop-types';
import { Tooltip } from 'devextreme-react/tooltip';
import withRouter from '../../util/customWithRouter';
import { TradeStatsHeader } from '../TradeStatsHeader';
import { PageLinkMenu } from '../PageLinkMenu';
import getAuth from '../../api/auth.js';
import { getTotalSummaryFromEcn, getTotalSummaryFromAts, getTotalSummaryFromIdqs, getTotalSummaryFromIdqsNight, getTotalSummaryFromIdqsNms, getTotalSummaryFromTdds } from '../../api/summary';
import { isEmpty, isEmptyArray, numberWithCommas, formatDollar } from '../../util/functions';
import * as Routes from '../../util/routeConstants';

const { REACT_ENV, TRADE_HEADER_WEB_SOCKET_API } = getConfig();
const SOCKET_ERROR_MAX_COUNT = 5;

const realTimeDataResAttr = new Map([
    ['ecn-trades-summary', 'ecnSummary'],
    ['ats-trades-summary', 'atsSummary'],
    ['tdds-trades-summary', 'tddsSummary'],
    ['idqs-trades-summary', 'idqsSummary'],
    ['idqs-trades-overnight-summary', 'idqsNightSummary'],
    ['moon-trades-summary', 'idqsNmsSummary'],
]);

const emptySummary = {
    tradeCount: 0
};

class AppHeader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showFilter: true,
            activeLink: '',
            activeMenu: '',
            versionTooltip: false,
            hamburgerMenuOpen: false,

            failedAttempt: SOCKET_ERROR_MAX_COUNT,
            wsObj: null,
            ecnSummary: emptySummary,
            atsSummary: emptySummary,
            idqsSummary: emptySummary,
            idqsNightSummary: emptySummary,
            idqsNmsSummary: emptySummary,
            tddsSummary: emptySummary,
            asOf: moment().format('MM/DD/YYYY')
        };
        this.onLinkChange = this.onLinkChange.bind(this);
        this.logout = this.logout.bind(this);
        this.toggleVersionTooltip = this.toggleVersionTooltip.bind(this);
        // ws stuff
        this.connect = this.connect.bind(this);
        this.checkToken = this.checkToken.bind(this);
    }

    toggleVersionTooltip() {
        this.setState({
            versionTooltip: !this.state.versionTooltip
        });
    }
    componentDidMount() {
        // update menu link
        this.updateLink();

        // connect to web socket for real time data
        this.connect();

        // call APIS to get latest state
        this.getTotalEcnTradeSummary();
        this.getTotalAtsTradeSummary();
        this.getTotalIdqsTradeSummary();
        this.getTotalIdqsNightTradeSummary();
        this.getTotalIdqsNmsTradeSummary();
        this.getTotalTddsTradeSummary();
    }

    componentDidUpdate() {
        this.updateLink();
    }

    componentWillUnmount() {
        this.state.wsObj && this.state.wsObj.close();
    }

  connect () {
    let socketApi =  TRADE_HEADER_WEB_SOCKET_API;
    if (socketApi && this.state.failedAttempt > 0) {
      const socket = new WebSocket(socketApi);
      // this is needed because  inside server this cant be avail
      const this_ = this;
      socket.addEventListener('open', function (event) {
        console.log('connected', socketApi);
      });
      socket.addEventListener('message', function (event) {
      // console.log('message from server: ' + event.data);
          const message = JSON.parse(event.data);
          const gridSummaryUpdateIdentifier = realTimeDataResAttr.get(message.topic);
          if (gridSummaryUpdateIdentifier) {
              this_.setState({
                  [gridSummaryUpdateIdentifier]: message,
                  failedAttempt: SOCKET_ERROR_MAX_COUNT
              });
          }
      });
      socket.addEventListener('error', function (event) {
        console.log('error in', socketApi);
        console.log('error', event);
        this_.setState({
          failedAttempt: this_.state.failedAttempt - 1
        });
      });
      socket.addEventListener('close', function (event) {
        // console.log('closed', event);
        if (event && event.code !== 1005) {
          this_.connect();
          this_.checkToken();
        }
      });

      this.setState({
        wsObj: socket
      });
    }
  };

    checkToken() {
        const portalAccess = window.localStorage.getItem('portalAccess');
        // only check token if user is logged in
        if (!portalAccess) {
            return;
        }
        
        getAuth(portalAccess)
            .then(data => {
                // all good
            })
            .catch((error) => {
                console.log(error);
                window.localStorage.removeItem('portalAccess');
                window.location.href = '/login';
            });

    }

    logout() {
        window.localStorage.removeItem('portalAccess');
        window.location.href = '/login';
    }

    toggleFilter = () => this.setState(state => ({ showFilter: !state.showFilter }));

    updateLink() {
        var url = window.location.href;
        if (url.includes(Routes.NMS_ORDER.path)) {
            this.onLinkChange(Routes.NMS_ORDER.key, Routes.NMS_ORDER.parentKey);
        } else if (url.includes(Routes.NMS_OPEN_ORDER.path)) {
            this.onLinkChange(Routes.NMS_OPEN_ORDER.key, Routes.NMS_OPEN_ORDER.parentKey);
        } else if (url.includes(Routes.NMS_TRADE.path)) {
            this.onLinkChange(Routes.NMS_TRADE.key, Routes.NMS_TRADE.parentKey);
        } else if (url.includes(Routes.IDQS_ORDER.path)) {
            this.onLinkChange(Routes.IDQS_ORDER.key, Routes.IDQS_ORDER.parentKey);
        } else if (url.includes(Routes.IDQS_OPEN_ORDER.path)) {
            this.onLinkChange(Routes.IDQS_OPEN_ORDER.key, Routes.IDQS_OPEN_ORDER.parentKey);
        } else if (url.includes(Routes.IDQS_TRADE.path)) {
            this.onLinkChange(Routes.IDQS_TRADE.key, Routes.IDQS_TRADE.parentKey);
        } else if (url.includes(Routes.ORDER.path)) {
            this.onLinkChange(Routes.ORDER.key, Routes.ORDER.parentKey);
        } else if (url.includes(Routes.TRADE.path)) {
            this.onLinkChange(Routes.TRADE.key, Routes.TRADE.parentKey);
        } else if (url.includes(Routes.TRADE_SUMMARY.path)) {
            this.onLinkChange(Routes.TRADE_SUMMARY.key, Routes.TRADE_SUMMARY.parentKey);
        } else if (url.includes(Routes.DASHBOARD.path) || url.includes(Routes.HISTORIC_DASHBOARD.path) || url.includes(Routes.MOBILE_DASHBOARD.path)
            || url.includes(Routes.RISK_DASHBOARD.path) || url.includes(Routes.HISTORY_RISK_DASHBOARD.path)
            || url.includes(Routes.ATS_TDDS_DASHBOARD.path) || url.includes(Routes.OVERNIGHT_DASHBOARD.path)
            || url.includes(Routes.ATS_TDDS_HISTORIC_DASHBOARD.path) || url.includes(Routes.HISTORIC_OVERNIGHT_DASHBOARD.path)) {
            this.onLinkChange(Routes.DASHBOARD.key, Routes.DASHBOARD.parentKey);
        } else if (url.includes(Routes.OPEN_ORDER.path)) {
            this.onLinkChange(Routes.OPEN_ORDER.key, Routes.OPEN_ORDER.parentKey);
        } else if (url.includes(Routes.ORDER_BOOK.path)) {
            this.onLinkChange(Routes.ORDER_BOOK.key, Routes.ORDER_BOOK.parentKey);
        } else if (url.includes(Routes.HELP.path)) {
            this.onLinkChange(Routes.HELP.key, Routes.HELP.parentKey);
        } else {
            this.onLinkChange('', '');
        }
    }

    onLinkChange(link, menu) {
        this.setState({
            activeLink: link,
            activeMenu: menu
        });
    }

    getTotalTradeSummary(apiFunction, stateKey, systemName) {
        apiFunction()
            .then(data => {
                // set only if socket did not return data
                if (!this.state[stateKey] || this.state[stateKey].tradeCount === 0) {
                    if (undefined === data || data.length === 0) {
                        console.log(`No ${systemName} Total Trade Summary Data Found`);
                        this.setState({
                            [stateKey]: emptySummary
                        });
                    } else {
                        this.setState({
                            [stateKey]: data
                        });
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    getTotalEcnTradeSummary() {
        this.getTotalTradeSummary(getTotalSummaryFromEcn, 'ecnSummary', 'ECN');
    }

    getTotalAtsTradeSummary() {
        this.getTotalTradeSummary(getTotalSummaryFromAts, 'atsSummary', 'ATS');
    }

    getTotalIdqsTradeSummary() {
        this.getTotalTradeSummary(getTotalSummaryFromIdqs, 'idqsSummary', 'IDQS');
    }

    getTotalIdqsNightTradeSummary() {
        this.getTotalTradeSummary(getTotalSummaryFromIdqsNight, 'idqsNightSummary', 'IDQS Night');
    }

    getTotalIdqsNmsTradeSummary() {
        this.getTotalTradeSummary(getTotalSummaryFromIdqsNms, 'idqsNmsSummary', 'IDQS NMS');
    }

    getTotalTddsTradeSummary() {
        this.getTotalTradeSummary(getTotalSummaryFromTdds, 'tddsSummary', 'TDDS');
    }

    renderTradeStats() {
        // Calculate Day Total (ECN+IDQS) combined stats (reference: line 243 for trade calculation)
        const dayTotalStats = {
            tradeCount: (this.state.ecnSummary.tradeCount || 0) + (this.state.idqsSummary.tradeCount || 0),
            volume: (this.state.ecnSummary.volume || 0) + (this.state.idqsSummary.volume || 0),
            notional: (this.state.ecnSummary.notional || 0) + (this.state.idqsSummary.notional || 0)
        };
        
        // Calculate Night Total (Night NMS + Night OTC) combined stats
        const nightTotalStats = {
            tradeCount: (this.state.idqsNmsSummary.tradeCount || 0) + (this.state.idqsNightSummary.tradeCount || 0),
            volume: (this.state.idqsNmsSummary.volume || 0) + (this.state.idqsNightSummary.volume || 0),
            notional: (this.state.idqsNmsSummary.notional || 0) + (this.state.idqsNightSummary.notional || 0)
        };
        
        // Calculate ATS+TDDS Total combined stats
        const atsTddsTotal = {
            tradeCount: (this.state.atsSummary.tradeCount || 0) + (this.state.tddsSummary.tradeCount || 0),
            volume: (this.state.atsSummary.volume || 0) + (this.state.tddsSummary.volume || 0),
            notional: (this.state.atsSummary.notional || 0) + (this.state.tddsSummary.notional || 0)
        };
        
        // Calculate Day/Night Total combined stats (ECN+IDQS+Night NMS+Night OTC)
        const dayNightTotalStats = {
            tradeCount: (this.state.ecnSummary.tradeCount || 0) + (this.state.idqsSummary.tradeCount || 0) + (this.state.idqsNightSummary.tradeCount || 0) + (this.state.idqsNmsSummary.tradeCount || 0),
            volume: (this.state.ecnSummary.volume || 0) + (this.state.idqsSummary.volume || 0) + (this.state.idqsNightSummary.volume || 0) + (this.state.idqsNmsSummary.volume || 0),
            notional: (this.state.ecnSummary.notional || 0) + (this.state.idqsSummary.notional || 0) + (this.state.idqsNightSummary.notional || 0) + (this.state.idqsNmsSummary.notional || 0)
        };
        
        if (!isEmptyArray(this.props.validUser) && !isEmpty(window.localStorage.getItem('portalAccess'))) {
            return <div className={styles.tradeStats}>
                <div key='ecnIdqsInfo'>
                    <div className={styles.tradeStatsSystem}>
                        <div className={styles.headerItem}>{'System'}</div>
                        <div className={styles.headerItem}>{'Trades'}</div>
                        <div className={styles.headerItem}>{'Volume'}</div>
                        <div className={styles.headerItem}>{'Notional'}</div>
                        <div className={styles.headerItem}>{this.state.asOf}</div>
                    </div>
                    <div className={styles.tradeStatsSystem}>
                        <TradeStatsHeader title='IDQS' valueStyle={styles.statItem} titleStyle={styles.systemItem} tradeTotalStats={this.state.idqsSummary}/>
                    </div>
                    <div className={styles.tradeStatsSystem}>
                        <TradeStatsHeader title='ECN' valueStyle={styles.statItem} titleStyle={styles.systemItem} tradeTotalStats={this.state.ecnSummary}/>
                    </div>

                    <div className={classNames(styles.tradeStatsSystem, styles.totalDiv)}>
                    <div className={styles.totalLabel}>{'Day Total'}</div>
                        <div className={styles.statItem}><span>{numberWithCommas(dayTotalStats.tradeCount)}</span></div>
                        <div className={styles.statItem}><span>{numberWithCommas(dayTotalStats.volume)}</span></div>
                        <div className={styles.statItem}><span>{formatDollar(dayTotalStats.notional)}</span></div>
                    </div>
                </div>
                <div key='atdTddsInfo'>
                <div className={styles.tradeStatsSystem}>
                        <div className={styles.headerItem}>{'System'}</div>
                        <div className={styles.headerItem}>{'Trades'}</div>
                        <div className={styles.headerItem}>{'Volume'}</div>
                        <div className={styles.headerItem}>{'Notional'}</div>
                        <div className={styles.headerItem}>{this.state.asOf}</div>
                    </div>
                    <div className={styles.tradeStatsSystem}>
                        <TradeStatsHeader title='ATS' valueStyle={styles.statItem} titleStyle={styles.systemItem} tradeTotalStats={this.state.atsSummary}/>
                    </div>
                    <div className={styles.tradeStatsSystem}>
                        <TradeStatsHeader title='TDDS' valueStyle={styles.statItem} titleStyle={styles.systemItem} tradeTotalStats={this.state.tddsSummary}/>
                    </div>
                </div>
                <div key='nightInfo'>
                    <div className={styles.tradeStatsSystem}>
                        <div className={styles.headerItem}>{'System'}</div>
                        <div className={styles.headerItem}>{'Trades'}</div>
                        <div className={styles.headerItem}>{'Volume'}</div>
                        <div className={styles.headerItem}>{'Notional'}</div>
                        <div className={styles.headerItem}>{this.state.asOf}</div>
                    </div>
                    <div className={styles.tradeStatsSystem}>
                        <TradeStatsHeader title='Night NMS' valueStyle={styles.statItem} titleStyle={styles.systemItem} tradeTotalStats={this.state.idqsNmsSummary}/>
                    </div>
                    <div className={styles.tradeStatsSystem}>
                        <TradeStatsHeader title='Night OTC' valueStyle={styles.statItem} titleStyle={styles.systemItem} tradeTotalStats={this.state.idqsNightSummary}/>
                    </div>
                    <div className={classNames(styles.tradeStatsSystem, styles.totalDiv)}>
                        <div className={styles.totalLabel}>{'Night Total'}</div>
                        <div className={styles.statItem}><span>{numberWithCommas(nightTotalStats.tradeCount)}</span></div>
                        <div className={styles.statItem}><span>{numberWithCommas(nightTotalStats.volume)}</span></div>
                        <div className={styles.statItem}><span>{formatDollar(nightTotalStats.notional)}</span></div>
                    </div>
                    
                    <div className={classNames(styles.tradeStatsSystem, styles.granDtotalDiv)}>
                        <div className={styles.totalLabel}>{'Day/Night Total'}</div>
                        <div className={styles.statItem}><span>{numberWithCommas(dayNightTotalStats.tradeCount)}</span></div>
                        <div className={styles.statItem}><span>{numberWithCommas(dayNightTotalStats.volume)}</span></div>
                        <div className={styles.statItem}><span>{formatDollar(dayNightTotalStats.notional)}</span></div>
                    </div>
                </div>
            </div>;
        }
    }

    render() {
        const headerText = REACT_ENV && REACT_ENV !== 'prod' ? ` ${REACT_ENV} - ${process.env.REACT_APP_VERSION}` : ` ${process.env.REACT_APP_VERSION} `;
        return (
            <div id='appHeaderComponent'>
                <div id='appHeader' className={styles.appHeader}>
                    <div id='content' className={styles.content}>
                        <div className={styles.logoContainer}>
                            <div>
                                <img id='logoDiv' onMouseEnter={this.toggleVersionTooltip} onMouseLeave={this.toggleVersionTooltip} className={styles.logo} alt='logo' src={'/images/otc-tps.svg'} />
                                <Tooltip
                                    target={'#logoDiv'}
                                    position='bottom'
                                    visible={this.state.versionTooltip}
                                    hideOnOutsideClick={false}
                                >{headerText}</Tooltip>
                            </div>
                            {this.props.validUser && <div id='div-mobileLogout' className={styles.mobileLogout}><span >
                                <FaSignOutAlt className={styles.signOutElement} onClick={this.logout} />
                            </span></div>}
                        </div>

                        <div id='div-pageLinkMenu' className={styles.pageLinkMenuDiv}>
                            <PageLinkMenu
                                validUser={this.props.validUser}
                                pageAccess={this.props.pageAccess}
                                isDesktop
                                onLinkChange={this.onLinkChange} activeLink={this.state.activeLink}
                                activeMenu={this.state.activeMenu}
                                logout={this.logout} />
                        </div>
                    </div>
                </div>
                {this.props.validUser && <div id='tradStatsDiv' className={styles.statsDiv}>
                    {this.state.showFilter && <div id='div-stats'>{this.renderTradeStats()}</div>}
                    <div className={styles.toggle} onClick={this.toggleFilter}>
                        {this.state.showFilter && <FaAngleDoubleUp />}
                        {!this.state.showFilter && <FaAngleDoubleDown />}
                    </div>
                </div>}
            </div>
        );
    }
}

export default withRouter(AppHeader);

AppHeader.propTypes = {
    validUser: PropTypes.array,
    pageAccess: PropTypes.object
};
